import { Outlet } from 'react-router-dom';
import { AppNav } from './AppNav';

export function AppLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <AppNav />
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
